import {Slide, toast} from "react-toastify";

export const toastError = (message) => {
  toast.error(message, {
    position: "bottom-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: false,
    style: { backgroundColor: "#3c3b3b", color: "#ffffff", fontWeight: 200 },
    transition: Slide
  });
}

export const toastSuccess = (message) => {
  toast.success(message, {
    position: "bottom-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: false,
    style: { backgroundColor: "#3c3b3b", color: "#ffffff" },
    transition: Slide
  });
}